import { ALL_DEPARTMENTS_ID } from '../config'

const getJobsWithDepartment = ({ jobs, isFiltered, department }) => jobs.reduce((acc, job) => {
  const division = job.customField.find((customField) => customField.fieldLabel === 'Division')

  if (isFiltered && division?.valueId !== department) {
    return acc
  }

  return [...acc, { ...job, department: division?.valueLabel }]
}, [])

const filterByDepartment = (jobs, department) => {
  if (!department || department === ALL_DEPARTMENTS_ID) {
    return getJobsWithDepartment({ jobs })
  }

  return getJobsWithDepartment({
    jobs,
    isFiltered: true,
    department,
  })
}

export { filterByDepartment }
